import React from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { Namespace } from '../../../translation/namespace';
import { PageType } from '../../../types/api/PageType';
// todo: make translatePageType typesafe by using this type:
// import PageTypeTranslation from '../../../translation/de/components/PageType-de';
// type TranslatablePageTypes = keyof typeof PageTypeTranslation;

type PageTypeTitleProps = {
  pageType: PageType;
};
export function PageTypeTitle({ pageType }: PageTypeTitleProps) {
  const { t } = useTranslation(Namespace.PageType);
  return <>{t(`${pageType}.title`)}</>;
}

export function translatePageType(pageType: PageType): string {
  return i18next.t(`${Namespace.PageType}:${pageType}.title`);
}

/**
 * Retrieve PageType Translations.
 * Special on2 pageTypes need the legacy Title here.
 */
export function translatePageTypeWithLegacyTitle(pageType: PageType): string {
  switch (pageType) {
    case 'on2blog':
    case 'on2blogpost':
    case 'on2wiki':
      return i18next.t(`${Namespace.PageType}:${pageType}.legacyTitle`);
    default:
      return translatePageType(pageType);
  }
}

export function hasTranslation(pageType: PageType) {
  return i18next.exists(`${Namespace.PageType}:${pageType}.title`);
}
